import { Switch, Route } from "react-router-dom";
import ChangePassword from "./Changepassword";
import ForgotPassword from "./Forgotpassword";
import Home from "./Home";
import Login from "./Login";
import NotFound from "./Notfound";
import ResetPassword from "./Resetpassword";
import Assistants from "./Assistants";
import SignUp from "./Signup";
import WorkInProgress from "./Workinprogress";
import LisPresta from "./Lispresta";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";

const Approuter = () => {
	return (
		<>
    <ScrollToTop/>
			<Switch>
				<Route path="/" exact={true}>
					<Home />
				</Route>
				<Route path="/login">
					<Login />
				</Route>
				<Route path="/signup">
					<SignUp />
				</Route>
				<Route path="/forgotpassword">
					<ForgotPassword />
				</Route>
				<Route path="/resetpassword/:token">
					<ResetPassword />
				</Route>
				<Route path="/changepassword">
					<ChangePassword />
				</Route>
				<Route path="/assistants">
					<Assistants />
				</Route>
				<Route path="/lispresta">
					<LisPresta />
				</Route>
				<Route path="/forum">
					<WorkInProgress />
				</Route>
				<Route>
					<NotFound />
				</Route>
			</Switch>
		</>
	);
};

export default Approuter;
